import Vue from 'vue';
import { computed } from '@vue/composition-api';
import InputField from '@/components/common/InputField.vue';
import PageHeader from '@/components/common/PageHeader.vue';
import FavouriteOptions from '@/components/common/FavouriteOptions.vue';
import Divider from '@/components/common/CommonDivider.vue';
import useMapFields from '@/hooks/useMapFields';
import { Mutations } from '@/util/settings/enums';
import RequiredFieldsWarning from '@/components/common/RequiredFieldsWarning.vue';
export default Vue.extend({
    components: {
        InputField,
        PageHeader,
        FavouriteOptions,
        Divider,
        RequiredFieldsWarning
    },
    setup(props, { root }) {
        const content = computed(() => root.$store.state.Content.content);
        const setFirstName = useMapFields(root, 'Profile', 'firstName', Mutations.SET_USER_FIRST_NAME_VALUE);
        const setSurname = useMapFields(root, 'Profile', 'familyName', Mutations.SET_USER_FAMILY_NAME_VALUE);
        const setUserTitle = useMapFields(root, 'Profile', 'userTitle', Mutations.SET_USER_TITLE_VALUE);
        return {
            content,
            setFirstName,
            setSurname,
            setUserTitle
        };
    }
});
